import React from "react";
import Image from "next/image";
import Box from "../components/Common/Box/Box";
import CommerceTimeline from "../components/CommerceAI/CommerceTimeline/CommerceTimeline";
import styles from "../styles/commerceAi.module.scss";
import CommerceAISection from "../components/CommerceAI/CommerceAISection/CommerceAISection";
import dynamic from "next/dynamic";
import Button from "../components/Common/Button/Button";
// import CardCommerce from "../components/CommerceAI/CardAndData/CardCommerce";
const Marquee = dynamic(() => import("react-fast-marquee"), { ssr: false });

const CommerceAI = () => {
  return (
    <div className={styles["commerece-ai-container"]}>
      <div className={styles["commerece-ai-header"]}>
        <h1>Data Intelligence that helps you Drive Retail Growth</h1>
        <p>
          Sophisticated eCommerce Insights served via Scalable APIs, Custom Data
          Exports, & SaaS Portal
        </p>
        <Button text="See it in action" />
      </div>
      <div className={styles["commerece-ai-section-1"]}>
        <Image
          className={styles["commerece-ai-section-1-img"]}
          src={"/commerce-ai-img.png"}
          height={500}
          width={900}
          alt=""
        ></Image>
      </div>
      <div className={styles["commerece-ai-section-2"]}>
        <p>
          Trusted by category leaders around the globe and across all retail
          industries
        </p>
        <Marquee style={{ zIndex: -1 }} speed={100}>
          <div className={styles["box-1"]}>
            <Box
              path="/companyLogo/zalon-logo.svg"
              width={280}
              height={72}
              alt={"Zalon"}
            />
            <Box
              path="/companyLogo/lal-10.webp"
              width={280}
              height={72}
              alt={"Lal 10"}
            />
            <Box
              path="/companyLogo/blinktrust.webp"
              width={280}
              height={72}
              alt={"Blinktrust"}
            />

            <Box
              path="/companyLogo/native.webp"
              width={280}
              height={72}
              alt={"Native"}
            />
            <Box
              path="/companyLogo/two-brothers.webp"
              width={280}
              height={72}
              alt={"Two Brothers"}
            />
            <Box
              path="/companyLogo/wishbox.webp"
              width={280}
              height={72}
              alt={"Wishbox"}
            />

            <Box
              path="/companyLogo/lawyered.webp"
              width={280}
              height={72}
              alt="Lawyered"
            />
            <Box
              path="/companyLogo/matrix-media.webp"
              width={280}
              height={72}
              alt="Matrix"
            />
            <Box
              path="/companyLogo/profluence.webp"
              width={280}
              height={72}
              alt="Profluence"
            />
          </div>
        </Marquee>
      </div>
      <div className={styles["commerece-ai-section-3"]}>
        <CommerceTimeline />
      </div>
      <div className={styles["commerece-ai-section-4"]}>
        <h1>
          Advanced Retail APIs for <br />
          Unmatched Speed and Accuracy{" "}
        </h1>
        <div className={styles["commerece-ai-section-4-content"]}>
          <p>
            To thrive In the age of Amazon, you need superior, accurate data
            across pricing, assortments, content, and visibility and you need it
            now!
            <br />
            <br />
            With Intelligence Node’s Data Intelligence, upgrade to AI-powered
            decision-making by integrating the world’s largest, most accurate
            retail data feed with your internal software.
          </p>
          <p>
            It’s time to minimize costs and the risks that come with setting up
            data teams and in-house infrastructure. With 10-second data refresh
            rates and 99% product matching accuracy, leverage sophisticated
            insights that give you a competitive edge. Choose from a variety of
            APIs for your every need and access structured information in your
            preferred format: JSON, XML, HTML, text, auto. With minimum to no
            integrations, go live in days not weeks or months, and start making
            data-driven decisions, fast.
          </p>
        </div>
      </div>
      <div className={styles["commerece-ai-section-5"]}>
        <h1>Plug & Play APIs for Your Assortment Planning</h1>
        <p>
          We know that no two businesses have the same needs. Hence, we offer
          you the flexibility to access just the type of data your business
          requires, the way you want it. Leverage real-time data insights and
          advanced analytics with retail APIs crafted for your unique
          requirements and beat the giants at their own game!
        </p>

        <CommerceAISection />
      </div>
      {/* <div className={styles["commerece-ai-section-6"]}>
        <div className={styles["commerece-ai-section-left"]}>
          <h1>
            Multi-layered Security Fortifications for Utmost Data Reliability
          </h1>
          <p>
            At Intelligence Node, maintaining the highest levels of data
            security is our top priority. We have an enhanced breach
            notification and detailed reporting system in place to address,
            notify, and remediate any data breach immediately. To ensure our
            customer’s data security and privacy, we use an NIST Cybersecurity
            Framework and are GDPR compliant. Additionally, being an all-access
            cloud company, all our data is stored, secured, and provided using
            two services: Google Cloud Security and Compliance (for user related
            data) and IBM cloud (for product data lake).
            <br />
            <br />
            We offer single sign-on and multi-factor authentication to our
            customers and authorize external logging only after whitelisting
            requested IPs. We also follow a 3-layered disaster recovery process
            as an additional layer of security. With these multi-tiered security
            defences, you can rest assured that your data is safe with us.
          </p>
        </div>
        <div className={styles["commerece-ai-section-right"]}>
          <Image
            className={styles["commerece-ai-section-img"]}
            src={"/commerce-section-6.webp"}
            height={340}
            width={540}
            alt=""
          ></Image>
        </div>
      </div>
      <div className={styles["commerece-ai-section-7"]}>
        <div className={styles["commerece-ai-section-left"]}>
          <Image
            className={styles["commerece-ai-section-img"]}
            src={"/commerce-section-7.webp"}
            height={340}
            width={540}
            alt=""
          ></Image>
        </div>
        <div className={styles["commerece-ai-section-right"]}>
          <h1>Highest Data Quality, Rapid ROI</h1>
          <p>
            When it comes to superior data, we have all your bases covered. You
            tell us what competitors, products, and categories to track and we
            deploy sophisticated crawling capabilities across the global
            eCommerce market to get that data to you instantly, in a simplified,
            structured format, and at half the cost.
            <br />
            <br />
            Our AI-powered APIs reduce the demands on in-house data teams and
            empower you to make data-driven decisions based on smart, calculated
            recommendations.
          </p>
        </div>
      </div>
      <div className={styles["commerece-ai-section-8"]}>
        <div className={styles["commerece-ai-section-left"]}>
          <h1>Powered by Proprietary Big Data & Machine Learning Technology</h1>
          <p>
            Intelligence Node’s state-of-the-art data analytics platform is a
            unique combination of internally developed proprietary machine
            learning technology and advanced big data tools like MongoDB,
            Aerospike DB, Elastics Search, and Spark. We pride ourselves on
            maintaining one of the largest, and most accurate retail product
            databases of over 1 billion unique products across 1400 categories
            and 190k brands.
            <br />
            From 99% product matching accuracy to 10-second data refresh rates,
            we make comprehensive, accurate data insights available to brands
            and retailers, fast, so they can identify and act upon the
            information within minutes.
          </p>
        </div>
        <div className={styles["commerece-ai-section-right"]}>
          <Image
            className={styles["commerece-ai-section-img"]}
            src={"/commerce-section-8.webp"}
            height={340}
            width={540}
            alt=""
          ></Image>
        </div>
      </div>
      <div className={styles["commerece-ai-section-9"]}>
        <div className={styles["commerece-ai-section-left"]}>
          <Image
            className={styles["commerece-ai-section-img"]}
            src={"/commerce-section-9.webp"}
            height={340}
            width={540}
            alt=""
          ></Image>
        </div>
        <div className={styles["commerece-ai-section-right"]}>
          <h1>Multi-Access Online SaaS Portal & Custom Exports</h1>
          <p>
            Access data at any time by logging into our secure SaaS portal from
            anywhere in the world. Our intuitive interface lets you monitor the
            metrics that matter to you most and makes generating reports easy.
            It helps you see right through the competitor’s pricing, promotion,
            and catalog strategies and gives you smart insights and
            recommendations to make fast and accurate decisions. With multiple
            functionalities like notifications, relationship charts, daily
            dashboard, and filters, you can easily track, analyze, and compare
            competitor movements 24x7.
            <br />
            <br />
            With custom exports, get extensive data files delivered to your
            inbox so you can access them at your leisure and derive actionable
            insights from them.
          </p>
        </div>
      </div>
      <div className={styles["commerece-ai-section-10"]}>
        <div className={styles["commerece-ai-section-left"]}>
          <h1>Dynamic Pricing & Price Optimization for Shopify</h1>
          <p>
            With our newly launched ‘PriceIntelligence AI’ app on the Shopify
            App Store, we are making our AI-driven eCommerce analytics and
            dynamic pricing available for Shopify retailers as well. Now track,
            monitor, and compare against your competitor prices multiple times a
            day and review and update prices on your Shopify store
            instantaneously.
            <br />
            <br /> Get the flexibility to create your own pricing rules and
            choose to automatically update your online prices to never miss
            another opportunity. Our affordable pricing plans (including a free
            Starter plan) are leveling the eCommerce playing field by making
            superior data analytics accessible to even the smaller players in
            the retail ecosystem.
          </p>
        </div>
        <div className={styles["commerece-ai-section-right"]}>
          <Image
            className={styles["commerece-ai-section-img"]}
            src={"/commerce-section-10.webp"}
            height={340}
            width={540}
            alt=""
          ></Image>
        </div>
      </div> */}
    </div>
  );
};

export default CommerceAI;
